import { Container, Row, Col } from 'reactstrap';

interface IStepWrapper {
  children: React.ReactNode;
}

const StepWrapper: React.FC<IStepWrapper> = ({ children }) => {
  return (
    <Container>
      <Row className="mt-xxxl">
        <Col
          xs={12}
          sm={{ size: 8, offset: 2 }}
          md={{ size: 6, offset: 3 }}
          className="text-center"
        >
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default StepWrapper;
